import { render } from "./MainTutorial.vue?vue&type=template&id=3cd5a7a0&scoped=true&ts=true"
import script from "./MainTutorial.vue?vue&type=script&lang=ts"
export * from "./MainTutorial.vue?vue&type=script&lang=ts"

import "./MainTutorial.vue?vue&type=style&index=0&id=3cd5a7a0&lang=stylus"
import "./MainTutorial.vue?vue&type=style&index=1&id=3cd5a7a0&lang=stylus&scoped=true"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cd5a7a0"]])

export default __exports__